// src/combobox/combobox-context.ts
import { createContext } from "react";
var ComboboxContext = createContext(
  void 0
);
var ComboboxItemValueContext = createContext(
  void 0
);

export {
  ComboboxContext,
  ComboboxItemValueContext
};
